var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/VirtualStandardSize.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VirtualStandardSize = ({
  color = '#353B60',
  opacity = '0.25',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_6117_129202)",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "1.98682",
      y: "1",
      width: "22",
      height: "22",
      rx: "3",
      stroke: color,
      strokeOpacity: "0.15",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      opacity: opacity,
      d: "M13.9868 7C13.9868 6.44772 14.4345 6 14.9868 6H18.9868C19.5391 6 19.9868 6.44772 19.9868 7V17C19.9868 17.5523 19.5391 18 18.9868 18H14.9868C14.4345 18 13.9868 17.5523 13.9868 17V7Z",
      fill: color
    }), /*#__PURE__*/_jsx("rect", {
      opacity: opacity,
      x: "5.98682",
      y: "12",
      width: "6",
      height: "6",
      rx: "1",
      fill: color
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_6117_129202",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.986816)"
      })
    })
  })]
});